import { useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { AlertTriangle } from "lucide-react";

const brl = (v) => Number(v || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 4 });
const num = (v) => Number(v || 0).toLocaleString("pt-BR", { maximumFractionDigits: 4 });

function Conteudo({ d }) {
  const c = d.custo || {};
  return (
    <div className="space-y-3 text-sm">
      <div data-testid="saldo-produto"><span className="text-muted-foreground">Produto:</span> <b>{d.produto?.nome}</b> <span className="font-mono text-primary">({d.produto?.sku})</span></div>
      <table className="w-full text-xs" data-testid="saldo-tabela">
        <thead><tr className="text-muted-foreground text-left"><th className="py-1">Unidade</th><th className="text-right">Quantidade</th><th className="text-right">Custo unit.</th><th className="text-right">Custo total</th></tr></thead>
        <tbody>{(d.saldos || []).map((s) => (
          <tr key={s.unidade} className="border-t border-border/60"><td className="py-1">{s.unidade_codigo ? `${s.unidade_codigo} — ` : ""}{s.unidade}</td>
            <td className="text-right font-mono">{num(s.quantidade)} {s.unidade_medida}</td><td className="text-right font-mono">{brl(s.custo_unit)}</td><td className="text-right font-mono">{brl(s.custo_total)}</td></tr>))}</tbody>
      </table>
      <div className="text-xs text-muted-foreground" data-testid="saldo-origem-custo">Custo atribuído a partir do <b>cadastro</b> (preço de compra {brl(c.preco_compra)} por {c.unidade_compra || "un."} ÷ conversão {num(c.fator_conversao)}). Não é custo histórico: o estoque de pedidos não registra custo.</div>
      {c.zerado && <div className="flex gap-2 rounded-md border border-amber-500/50 bg-amber-500/10 p-2 text-amber-300 text-xs" data-testid="saldo-custo-zerado">
        <AlertTriangle className="w-4 h-4 shrink-0" /> O preço de compra está zerado: o lote entrará com custo R$ 0,00. Cancele e informe o preço na aba Produção se quiser outro custo.</div>}
      <div className="text-xs">O saldo vira um lote <b>NÃO IDENTIFICADO</b> (validade desconhecida). Nenhuma quantidade é somada.</div>
    </div>
  );
}

export function useConfirmSaldo() {
  const [d, setD] = useState(null);
  const res = useRef(null);
  const ask = (detail) => new Promise((resolve) => { res.current = resolve; setD(detail); });
  const fechar = (ok) => { setD(null); res.current?.(ok); };
  const dialog = (
    <Dialog open={!!d} onOpenChange={(o) => !o && fechar(false)}>
      <DialogContent className="max-w-lg" data-testid="saldo-sem-lote-dialog">
        <DialogHeader><DialogTitle className="font-display uppercase">Saldo existente sem lote</DialogTitle>
          <DialogDescription>{d?.msg}</DialogDescription></DialogHeader>
        {d && <Conteudo d={d} />}
        <DialogFooter>
          <Button variant="outline" onClick={() => fechar(false)} data-testid="saldo-cancelar">Cancelar</Button>
          <Button onClick={() => fechar(true)} data-testid="saldo-confirmar">Confirmar e registrar lote</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
  return [ask, dialog];
}
